export enum StepsValues {
  SearchParams = 0,
  CarEquipment = 1,
  CarDelivery = 2,
}
